import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_44_1W_4_15_OP22',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_44_1w_4_15_usd',
		},
		primer: 'prd_7QnFzRmEJSoq',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 4.15,
		},
		originalPriceMap: {
			USD: 22,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 44,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		explicitTermsIntervalText: $tc('common.week_plural', 4), // 4 weeks
		billingSubtitlePeriodText: $tc('common.week_plural', 4), // '4 weeks'
		footerPeriodText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week'
		footerIntervalText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week'
	}),
}
